import { Tooltip, Typography } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useAuthStore } from '@eastcoal/auth/hooks/useStore'
import { EaPhoneIcon } from '@eastcoal/icon/EaPhone'

export const Manager = () => {
  const { member } = useAuthStore(state => pick(state, ['member']))

  return (
    <span>
      <span>客户经理:&nbsp;</span>
      {member.managerId ? (
        <Tooltip
          placement='top'
          trigger='hover'
          title={
            <Typography.Text
              copyable
              style={{
                color: '#fff'
              }}
            >
              {member.managerPhone ?? '获取中...'}
            </Typography.Text>
          }
        >
          {member.managerName}&nbsp;
          <EaPhoneIcon />
        </Tooltip>
      ) : (
        '未分配'
      )}
    </span>
  )
}
